import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

const LoadingText = ({ text = "Loading" }) => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount(prev => (prev + 1) % 4); // 0,1,2,3, then back to 0
    }, 500); // update every 500 ms (adjust as needed)
    return () => clearInterval(interval);
  }, []);

  return (
    <Typography variant="h6" color="text.secondary">
      {text}{'.'.repeat(dotCount)}
    </Typography>
  );
};

export default LoadingText;